import moment from 'moment';

export class Email {
    constructor(data) {
        var self = this;
        self.type = "Email";

        self.email_address = data.email_address;
        self.person_uuid = data.person_uuid;
        self.email_template_name = data.email_template_name;
        self.inserted = new moment(data.inserted);
        self.updated = data.updated;
        self.extra_notes = data.extra_notes;
        self.event_uuid = data.event_uuid;

        self.html_path = data.html_path;

        self.email_opened = data.email_opened;
        self.email_clicked = data.email_clicked;

        self.pretty_email_opened = ko.pureComputed(function () {
            if (self.email_opened) {
                return new moment(self.email_opened);
            }
        });

        self.pretty_email_clicked = ko.pureComputed(function () {
            if (self.email_clicked) {
                return new moment(self.email_clicked);
            }
        });

    }
}
